import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { onboardingKeys } from "@/lib/query-keys";
import type { SupplierPreview } from "@/types/domain";

/**
 * Obras con buena pro reciente que piden lo que vende el proveedor: el mismo
 * universo que mostrará su línea en el dashboard. Con `details` trae además las
 * buenas pro más recientes. Si falla, la pantalla sigue sin números.
 */
export function useSupplierPreview({
  terms,
  departmentIds,
  details = false,
  enabled = true,
}: {
  terms: string[];
  departmentIds: number[];
  details?: boolean;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: onboardingKeys.supplierPreview(terms, departmentIds, details),
    enabled: enabled && terms.length > 0,
    // Mientras llega el número nuevo se queda el anterior: un 0 de paso parpadea.
    placeholderData: keepPreviousData,
    retry: false,
    queryFn: () => {
      const params = new URLSearchParams({
        terms: terms.join(","),
        departmentIds: departmentIds.join(","),
        details: String(details),
      });
      return fetchToBackend<SupplierPreview>(
        `/onboarding/supplier-preview?${params}`,
      );
    },
  });
}
